import { render, staticRenderFns } from "./EmArchFixedAssetDisposalList.vue?vue&type=template&id=5676edc2&scoped=true&"
import script from "./EmArchFixedAssetDisposalList.vue?vue&type=script&lang=js&"
export * from "./EmArchFixedAssetDisposalList.vue?vue&type=script&lang=js&"
import style0 from "./EmArchFixedAssetDisposalList.vue?vue&type=style&index=0&id=5676edc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5676edc2",
  null
  
)

export default component.exports